import {
  AccountSurveyCounterCategoryAssociation,
  AccountSurveyCounterChargeCount,
  CategoryTypeIds,
} from '../store/taskManager/model'
import { NG_API_CLIENT } from 'services/api'
import { AccountSurveyCounter } from '../effectorStores/taskSurvey/model'

export const resetTaskCounter = (taskId: number) =>
  NG_API_CLIENT.restClient.instance
    .request({
      method: 'POST',
      url: `/task/${taskId}/reset-counter`,
      data: {},
    })
    .then(response => response)
    .catch(error => error.response)

export const buildAccountSurveyCounterCategoryAssociations = (
  store: AccountSurveyCounter
): AccountSurveyCounterCategoryAssociation[] => {
  return [
    {
      categoryId: CategoryTypeIds.connection,
      count: store.connectionDoneTaskCount,
      chargeCount: AccountSurveyCounterChargeCount.connection,
    },
    {
      categoryId: CategoryTypeIds.payment,
      count: store.paymentDoneTaskCount,
      chargeCount: AccountSurveyCounterChargeCount.payment,
    },
    {
      categoryId: CategoryTypeIds.openCabinet,
      count: store.openCabinetDoneTaskCount,
      chargeCount: AccountSurveyCounterChargeCount.openCabinet,
    },
    {
      categoryId: CategoryTypeIds.support,
      count: store.supportDoneTaskCount,
      chargeCount: AccountSurveyCounterChargeCount.support,
    },
    {
      categoryId: CategoryTypeIds.other,
      count: store.otherDoneTaskCount,
      chargeCount: AccountSurveyCounterChargeCount.other,
    },
  ]
}

export const resetAccountSurveyCounter = async (categoryId: number) =>
  NG_API_CLIENT.restClient.instance
    .request({
      method: 'POST',
      url: '/task/reset-account-survey-counter',
      data: { categoryId },
    })
    .then(response => response)
    .catch(error => error.response)
